/**
 * Up to two initials from a name, for an avatar that has no picture yet:
 * "Potomac River Alliance" gives "PR".
 */
export function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
